export function buildTradingAccountsRowsModel(dtoRows) {
  return dtoRows.map((item) => ({
    id: item.id,
    tradingServerId: item.tradingServerId,
    platform: item.platform,
    name: item.name,
    description: item.description,
    type: item.type,
    leverages: Array.isArray(item.leverages) ? item.leverages : [],
    currencies: Array.isArray(item.currencies) ? item.currencies : [],
    minimumDeposit: item.minimumDeposit === null || item.minimumDeposit === undefined ? null : item.minimumDeposit,
    group: item.group,
    platformUrl: item.platformUrl,
    stopOutPercent: item.stopOutPercent,
  }));
}

export function buildEmptyTradingAccountForm(defaultPlatform = '', capabilities = {}) {
  return {
    platform: defaultPlatform,
    capabilities,
    tradingServerId: '',
    name: '',
    description: '',
    platformUrl: '',
    type: capabilities.allowedAccountTypes?.length === 1 ? capabilities.allowedAccountTypes[0] : 'live',
    stopOutPercent: '50.00',
    leverages: [],
    currencies: capabilities.allowedCurrencies?.length === 1 ? [...capabilities.allowedCurrencies] : [],
    minimumDeposit: '',
    group: '',
  };
}

export function buildServerLabelMap(tradingServerOptions) {
  const map = new Map();
  (tradingServerOptions || []).forEach((server) => {
    map.set(server.id, server.name || server.id);
  });
  return map;
}
